// extracted by mini-css-extract-plugin
module.exports = {"box":"subscription-success_box___HNJL","code":"subscription-success_code__GUxc3"};